<div
  class="layout-column i-center c-center area-400px height-300px bdr-box bg-gray4 bdr-radius bdr-gray3 pointer"
  ngfDrop
  [selectable]=true
  [(files)]="files"
  multiple
  (filesChange)="onChangeFile()">
  <span class="ft-size-5 ft-weight-bold">Select or Drag and Drop</span>
</div>